type CurrencyType = 'RUB' | 'EUR' | 'USD';

export const formatCurrency = (
    value: number,
    currency: CurrencyType,
    options?: { maximumFractionDigits?: number; minimumFractionDigits?: number; style?: 'decimal' | 'currency' }
) => {
    return new Intl.NumberFormat('ru-RU', {
        currency,
        style: 'currency',
        currencyDisplay: 'symbol',
        ...options,
    }).format(value);
};
